
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const BASE_URL = process.env.REACT_APP_API_URL;

export const createOrder = createAsyncThunk('payment/createOrder', async (amount, { rejectWithValue }) => {
  try {
    const token = localStorage.getItem("token");
    const { data } = await axios.post(`${BASE_URL}/api/payment/create-order`, { amount }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (process.env.NODE_ENV === "development") {
      console.log("create order - payment data", data);
    }
    // verifyPayment(data);
    return data;
  } catch (error) {
    return rejectWithValue(
      error.response?.data
    );
  }
});

export const verifyPayment = createAsyncThunk('payment/verifyPayment', async (paymentDetails, { rejectWithValue }) => {
  if (process.env.NODE_ENV === "development") {
    console.log("verify Payment slice - paymentDetails", paymentDetails);
  }
  try {
    const token = localStorage.getItem("token");
    const { data } = await axios.post(`${BASE_URL}/api/payment/verify`, {
      razorpay_order_id: paymentDetails.razorpay_order_id,
      razorpay_payment_id: paymentDetails.razorpay_payment_id,
      razorpay_signature: paymentDetails.razorpay_signature
    }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (process.env.NODE_ENV === "development") {
      console.log("verify Payment - payment data", data);
    }
    return data;
  } catch (error) {
    return rejectWithValue(
      error.response?.data
    );
  }
});

const paymentSlice = createSlice({
  name: 'payment',
  initialState: {
    creatingOrder: false,
    verifyingPayment: false,
    order: null,
    verificationResult: null,
    error: null,
  },
  reducers: {
    resetPaymentState: (state) => {
      state.creatingOrder = false;
      state.verifyingPayment = false;
      state.order = null;
      state.verificationResult = null;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createOrder.pending, (state) => {
        state.creatingOrder = true;
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.creatingOrder = false;
        state.order = action.payload;
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.creatingOrder = false;
        state.error = action.payload || action.error.message;
      })

      .addCase(verifyPayment.pending, (state) => {
        state.verifyingPayment = true;
      })
      .addCase(verifyPayment.fulfilled, (state, action) => {
        state.verifyingPayment = false;
        state.verificationResult = action.payload;
      })
      .addCase(verifyPayment.rejected, (state, action) => {
        state.verifyingPayment = false;
        state.error = action.payload || action.error.message;
      })

  },
});

export default paymentSlice.reducer;
